
import httpClient from "@/plugins/axios";

export const changePassword = async (oldPassword, newPassword) => {
    const response = await httpClient.post('v1/auth/change-password',
        {
            old_password: oldPassword,
            new_password: newPassword
        });
    return response;
}

export const initLogin = async (usernameOrPhone) => {
    const response = await httpClient.post(`v1/auth/initlogin/`, {
        usernamephone: usernameOrPhone
    });

    return response;
}

export const usernameLogin = async (username, password) => {
    const response = await httpClient.post('/v1/auth/login/', {
        username,
        password
    });

    return response;
}

export const submitPhone = async (phone) => {
    const response = await httpClient.post(`v1/auth/mobilelogin/`, {
        phone_number: phone
    });

    return response;
}

export const submitPin = async (phone, pin, attemptId) => {
    const response = await httpClient.post(`v2/auth/otp/`, {
        phone_number: phone,
        pin_code: pin,
        attempt_id: attemptId
    });

    return response;
}

export const logout = async () => {
    const response = await httpClient.post("/v1/auth/logout/");
    return response;
}